// extracted by mini-css-extract-plugin
module.exports = {"sliderWrapper":"_2O6Lt","imageWrapper":"_2geVI","caption":"_3tDUW","subCaption":"_3ZJ6B","closeButton":"_16CoR"};